/* src/app/intro/intro-index/intro-index.component.scss */
swiper-container {
  height: 100%;
  margin-top: 2em;
  padding: 1em;
}
swiper-slide {
  height: 100%;
  display: block;
  text-align: left;
  overflow: auto;
  padding: 1em 1em 3em 1em;
  border-radius: 2em;
  background: #ffff00 url("./media/points.svg") no-repeat center top;
  background-size: cover;
}
swiper-slide.tipps {
  background: #ffff00 url("./media/bulb.svg") no-repeat center top;
}
swiper-slide.compass {
  background: #ffff00 url("./media/compass-white.svg") no-repeat center top;
}
.swiper-container {
  padding: 1em;
}
.swiper-slide:not(.swiper-slide-active) > div {
  display: none;
}
/*# sourceMappingURL=intro-index.component.css.map */
